"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../styles");
var definedSize = {
    sm: { minWidth: '3.2rem', minHeight: '3.2rem', padding: '0.5rem 1.5rem' },
    md: { minWidth: '12rem', minHeight: '4.7rem', padding: '1.3rem 2.7rem' },
};
var ButtonStyles = {
    primary: {
        backgroundColor: styles_1.theme.colors.lqBlue,
        textColor: '#fff',
        border: "1px solid transparent",
        hoverBgColor: styles_1.theme.colors.darkBlue,
        activeBgColor: styles_1.theme.colors.marinoBlue,
        disableBgColor: styles_1.theme.colors.regentGray,
    },
    secondary: {
        backgroundColor: '#fff',
        textColor: styles_1.theme.colors.lqBlue,
        border: "1px solid " + styles_1.theme.colors.lqBlue,
        hoverBorder: "1px solid " + styles_1.theme.colors.darkBlue,
        hoverTextColor: styles_1.theme.colors.darkBlue,
        activeBorder: "1px solid " + styles_1.theme.colors.marinoBlue,
        activeTextColor: styles_1.theme.colors.marinoBlue,
        disableBgColor: 'transparent',
        disabledBorder: "1px solid " + styles_1.theme.colors.regentGray,
        disabledTextColor: styles_1.theme.colors.regentGray,
    },
};
var StyledButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: inherit;\n  font-weight: bold;\n  line-height: 2rem;\n  letter-spacing: 0.25px;\n  background-color: ", ";\n  color: ", ";\n  border: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  width: 100%;\n  border-radius: ", ";\n  font-size: 1.4rem;\n  font-weight: ", ";\n  user-select: none;\n  padding: ", ";\n\n  :hover {\n    cursor: pointer;\n    background-color: ", ";\n    border: ", ";\n    color: ", ";\n  }\n\n  :active {\n    background-color: ", ";\n    border: ", ";\n    color: ", ";\n  }\n\n  :disabled {\n    cursor: auto;\n    pointer-events: none;\n    background-color: ", ";\n    border: ", ";\n    color: ", ";\n  }\n"], ["\n  font-family: inherit;\n  font-weight: bold;\n  line-height: 2rem;\n  letter-spacing: 0.25px;\n  background-color: ",
    ";\n  color: ", ";\n  border: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  width: 100%;\n  border-radius: ", ";\n  font-size: 1.4rem;\n  font-weight: ", ";\n  user-select: none;\n  padding: ", ";\n\n  :hover {\n    cursor: pointer;\n    background-color: ",
    ";\n    border: ", ";\n    color: ", ";\n  }\n\n  :active {\n    background-color: ",
    ";\n    border: ", ";\n    color: ", ";\n  }\n\n  :disabled {\n    cursor: auto;\n    pointer-events: none;\n    background-color: ",
    ";\n    border: ", ";\n    color: ",
    ";\n  }\n"])), function (props) {
    return ButtonStyles[props.buttonType].backgroundColor;
}, function (props) { return ButtonStyles[props.buttonType].textColor; }, function (props) { return ButtonStyles[props.buttonType].border; }, function (props) { return definedSize[props.size].minHeight; }, function (props) { return definedSize[props.size].minWidth; }, styles_1.theme.borderRadius.curvy, styles_1.theme.fontWeight.bold, function (props) { return definedSize[props.size].padding; }, function (props) {
    return ButtonStyles[props.buttonType].hoverBgColor;
}, function (props) { return ButtonStyles[props.buttonType].hoverBorder; }, function (props) { return ButtonStyles[props.buttonType].hoverTextColor; }, function (props) {
    return ButtonStyles[props.buttonType].activeBgColor;
}, function (props) { return ButtonStyles[props.buttonType].activeBorder; }, function (props) { return ButtonStyles[props.buttonType].activeTextColor; }, function (props) {
    return ButtonStyles[props.buttonType].disableBgColor;
}, function (props) { return ButtonStyles[props.buttonType].disabledBorder; }, function (props) {
    return ButtonStyles[props.buttonType].disabledTextColor;
});
exports.default = StyledButton;
var templateObject_1;
//# sourceMappingURL=Button.styled.js.map